import { TranslationKeys } from '../index';

export const zh: TranslationKeys = {
  betBuilder: {
    title: '投注构建器',
    noBetsSelected: '投注构建器为空',
    addSelections: '添加选择',
    totalOdds: '总赔率',
    totalSelections: '总选择数',
    clearAll: '清除全部',
    removeBet: '移除投注',
    addBet: '添加投注',
    event: '赛事',
    market: '市场',
    selection: '选择',
    odds: '赔率',
    confirmClear: '清除所有投注',
    confirmClearMessage: '您确定要移除所有投注吗？此操作无法撤销。',
    cancel: '取消',
    confirm: '清除全部',
    closed: '已关闭',
    suspend: '暂停',
    eventClosed: '赛事已关闭',
    eventSuspended: '赛事已暂停',
    buildABet: ''
  },
   betStatus: {
    won: '赢',
    pending: '待定',
    refund: '退款',
    lost: '输',
    halfwon: '半赢',
    halflost: '半输',
    cashout: '提现',
    unknown: '未知'
  },
  common: {
    loading: '加载中...',
    error: '错误',
    retry: '重试',
    close: '关闭',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    back: '返回',
    next: '下一个',
    previous: '上一个',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    settings: '设置'
  },
  errors: {
    generic: '出现了问题。请重试。',
    network: '网络错误。请检查您的连接。',
    notFound: '未找到请求的资源。',
    unauthorized: '您无权执行此操作。',
    validation: '请检查您的输入并重试。'
  }
};